module.exports = __webpack_public_path__ + "media/images/banners/12-ece952ade99bfda2aadc49662c26a3fb.png";